import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import ReactDOM from 'react-dom';
// import classnames from 'classnames';
// import { events } from '../utils';
// import { getViewport } from '../utils/utils';
import InjectMenuItem from './MenuItem';
import has from 'lodash/has';
import { Box, Menu as NBMenu, Pressable } from "native-base";

import { Sortable } from '~/native-ui/sortable/Sortable';

const POSITION = {
  AUTO: 'auto',
  STATIC: 'static',
  TOP_LEFT: 'topLeft',
  TOP_RIGHT: 'topRight',
  BOTTOM_LEFT: 'bottomLeft',
  BOTTOM_RIGHT: 'bottomRight',
};

const MENU_HEIGHT_AUTO = 'auto';
const MENU_OFFSET_FROM_EDGE = 30;

const factory = (MenuItem) => {
  class Menu extends Component {
    static propTypes = {
      orderable: PropTypes.bool,
      onReorder: PropTypes.func,
      config: PropTypes.object,
      active: PropTypes.bool,
      closeOnSelect: PropTypes.bool,
      children: PropTypes.node,
      className: PropTypes.string,
      onClose: PropTypes.func,
      onSelect: PropTypes.func,
      onShow: PropTypes.func,
      outline: PropTypes.bool,
      position: PropTypes.oneOf(Object.keys(POSITION).map(key => POSITION[key])),
      ripple: PropTypes.bool,
      selectable: PropTypes.bool,
      selected: PropTypes.node,
      trigger: PropTypes.func,
      theme: PropTypes.shape({
        active: PropTypes.string,
        bottomLeft: PropTypes.string,
        bottomRight: PropTypes.string,
        menu: PropTypes.string,
        menuInner: PropTypes.string,
        outline: PropTypes.string,
        rippled: PropTypes.string,
        static: PropTypes.string,
        topLeft: PropTypes.string,
        topRight: PropTypes.string,
      }),
    };

    static defaultProps = {
      outline: true,
      position: POSITION.STATIC,
      closeOnSelect: true,
      ripple: true,
      selectable: true,
    };

    state = {
      active: this.props.active,
      rippled: false,
    };

    get canReorder() {
      return !!this.props.orderable && !!this.props.onReorder
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.children.length === 0) {
        return;
      }

      if (this.props.children[0] && nextProps.children[0] && this.props.children[0].length !== nextProps.children[0].length) {
        this.setState({ height: MENU_HEIGHT_AUTO });
      }

      if (this.props.position !== nextProps.position) {
        const position = nextProps.position === POSITION.AUTO
          ? this.calculatePosition()
          : nextProps.position;
        this.setState({ position });
      }

      /**
       * If the menu is going to be activated via props and its not active, verify
       * the position is appropriated and then show it recalculating position if its
       * wrong. It should be shown in two consecutive setState.
       */
      // if (!this.props.active && nextProps.active && !this.state.active) {
      //   if (nextProps.position === POSITION.AUTO) {
      //     const position = this.calculatePosition();
      //     if (this.state.position !== position) {
      //       this.setState({ position, active: false }, () => {
      //         this.activateTimeoutHandle = setTimeout(() => { this.show(); }, 20);
      //       });
      //     } else {
      //       this.show();
      //     }
      //   } else {
      //     this.show();
      //   }
      // }

      /**
       * If the menu is being deactivated via props and the current state is
       * active, it should be hid.
       */
      // if (this.props.active && !nextProps.active && this.state.active) {
      //   this.hide();
      // }
    }

    componentWillUpdate(nextProps, nextState) {
      if (!this.state.active && nextState.active) {
        // events.addEventsToDocument({
        //   click: this.handleDocumentClick,
        //   touchstart: this.handleDocumentClick,
        // });
      }
    }

    componentDidUpdate(prevProps, prevState) {
      // if (prevState.active && !this.state.active) {
      //   if (this.props.onClose) this.props.onClose();
        // events.removeEventsFromDocument({
        //   click: this.handleDocumentClick,
        //   touchstart: this.handleDocumentClick,
        // });
      // } else if (!prevState.active && this.state.active && this.props.onShow) {
      //   this.props.onShow();
      // }
    }

    componentWillUnmount() {
      if (this.state.active) {
        // events.removeEventsFromDocument({
        //   click: this.handleDocumentClick,
        //   touchstart: this.handleDocumentClick,
        // });
      }
      clearTimeout(this.activateTimeoutHandle);
    }

    calculatePosition() {
      return;
      // const parentNode = ReactDOM.findDOMNode(this).parentNode;
      // if (!parentNode) return undefined;
      // const { top, left, height, width } = parentNode.getBoundingClientRect();
      // const { height: wh, width: ww } = getViewport();
      // const toTop = top < ((wh / 2) - (height / 2));
      // const toLeft = left < ((ww / 2) - (width / 2));
      // return `${toTop ? 'top' : 'bottom'}${toLeft ? 'Left' : 'Right'}`;
    }

    // handleDocumentClick = (event) => {
    //   if (this.state.active && !events.targetIsDescendant(event, ReactDOM.findDOMNode(this))) {
    //     this.setState({ active: false, rippled: false });
    //   }
    // };

    handleSelect = (item, event) => {

      const { value, onClick } = item.props;
      if (onClick) event.persist();
      this.setState({ active: !this.props.closeOnSelect, rippled: this.props.ripple }, () => {
        if (onClick) onClick(event);
        if (this.props.onSelect) this.props.onSelect(value);
      });
    };

    // getHeight(height = this.state.originalHeight) {
    //   const parentNode = ReactDOM.findDOMNode(this).parentNode;
    //   if (!parentNode) return undefined;

    //   const { height: vh } = getViewport();
    //   const { top: parentTop, height: parentHeight } = parentNode.getBoundingClientRect();
    //   const { marginTop, marginBottom } = getComputedStyle(this.menuNode.parentNode);
    //   const calculatedTop = parentTop + parseFloat(marginTop) + parseFloat(marginBottom);
    //   const fixToTop = parentTop < ((vh / 2) - (parentHeight / 2));

    //   let calculatedHeight = null;
    //   if (!fixToTop) {
    //     calculatedHeight = parentTop > height ? height : parentTop - MENU_OFFSET_FROM_EDGE;
    //   } else {
    //     calculatedHeight = (calculatedTop + height) < vh ? height : Math.abs(vh - calculatedTop) - MENU_OFFSET_FROM_EDGE;
    //   }

    //   return Math.min(height, calculatedHeight);
    // }

    show = () => {
      const { width, height } = this.menuNode ? this.menuNode.getBoundingClientRect() : { height: "100%", width: "100%"};
      // const height = this.getHeight() ||;
      this.setState({ active: true, height, width });
    }

    hide = () => {
      this.setState({ active: false });
    }

    renderItems() {
      return React.Children.map(this.props.children, (item, index) => {
        if (!item) return item;

        // only MenuItem has caption prop
        if (item.type.name === MenuItem.name) {
          return React.cloneElement(item, {
            index,
            orderable: has(item.props, "orderable") ? item.props.orderable : this.canReorder,
            selected: typeof item.props.value !== 'undefined'
              && this.props.selectable
              && item.props.value === this.props.selected,
            onClick: this.handleSelect.bind(this, item),
          });
        }

        return React.cloneElement(item);
      });
    }

    onOverlayClick = () => {
      this.setState({ active: false, rippled: false });
    }

    setMenuNode(node) {
      const calculateDimensions = this.menuNode === undefined;
      this.menuNode = node;

      // if (calculateDimensions) {
      //   this.show();
      // }
    }

    onReorder = (oldIndex, newIndex) => {
      this.props.onReorder(oldIndex, newIndex)
    }

    getMenuDragContainer = () => {
      return this.menuNode?.parentNode
    }

    getHelperContainer = () => {
      return this.menuNode?.parentNode
    }

    trigger = (triggerProps) => {
        const trigger = this.props.trigger?.(triggerProps) || null;

        
        if (!trigger) {
            return null;
        }

        return <Pressable { ...triggerProps }>{ trigger }</Pressable>
    }

    onOpen = (args) => {
      this.setState({ active: true })
      this.props.onOpen?.(...args)
    }

    onClose = (...args) => {
      this.setState({ active: false })
      this.props.onClose?.(...args)
    }


    renderMenu() {
      return (
        <NBMenu
            show
            shouldFlip
            maxHeight="50vh"
            trigger={ this.trigger }
            onOpen={this.props.onOpen}
            onClose={this.onClose}
            onKeyDown={this.props.onKeyDown}
            closeOnSelect={ this.props.closeOnSelect }
            shouldOverlapWithTrigger={this.props.shouldOverlapWithTrigger}
        >
          {this.renderMaybeDraggableMenu()}
        </NBMenu>
      )
    }

    renderMaybeDraggableMenu() {
      return !this.canReorder
        ? this.renderItems()
        : (
            <Sortable
              useDragHandle
              getContainer={this.getMenuDragContainer}
              onSortEnd={this.onReorder}
              lockToContainerEdges={true}
              axis="y"
              lockAxis="y"
            >
              <Box ref={(node) => { this.setMenuNode(node) }}>
                {this.renderItems()}
              </Box>
            </Sortable>
        )
    }

    render() {
    //   const { theme, reference, config } = this.props;
    //   const outlineStyle = { width: this.state.width, height: this.state.height };
    //   const className = classnames([theme.menu, theme[this.state.position]], {
    //     [theme.active]: this.state.active,
    //     [theme.rippled]: this.state.rippled,
    //   }, this.props.className);

      return (
        this.renderMenu()
        // <Popper
        //   config={config}
        //   onOverlayClick={ this.onOverlayClick }
        //   data-react-toolbox="menu"
        //   referenceElement={reference}
        //   className={ classnames(className, {  [theme.outline]: this.props.outline }) }
        //   show={ this.state.active }>
        //     {this.renderMaybeDraggableMenu()}
        // </Popper>
        //   <Menu
        //       shouldFlip
        //       closeOnSelect={ true }
        //     //   onOpen={() => console.log("opened")}
        //     //   onClose={() => console.log("closed")}
        //       trigger={(triggerProps) => {
        //           return (
        //               <Pressable {...triggerProps}>
        //                   <HamburgerIcon />
        //               </Pressable>
        //           )
        //       }}
        //   >
        //       <Menu.Group title="Profile">
        //           <Menu.Item>Menu item 1</Menu.Item>
        //           <Menu.Item>Menu item 2</Menu.Item>
        //       </Menu.Group>
        //       <Divider borderColor="gray.300" />
        //       <Menu.Group title="Help">
        //           <Menu.Item isDisabled>Menu item 3</Menu.Item>
        //           <Menu.Item>Menu item 4</Menu.Item>
        //       </Menu.Group>
        //   </Menu>
      );
    }
  }

  return Menu;
};

const Menu = factory(InjectMenuItem);
export { factory as menuFactory };
export default Menu;
export { Menu };
